<div>
  <app-navbar></app-navbar>
</div>

<div class="card bg-white">
  <div class="card-body">
    <div style="min-height: 500px">
      <!-- <xng-breadcrumb *ngIf="!showCustomBreadcrumb()" [autoGenerate]="false">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
          <b [routerLink]="breadcrumb.url">{{ breadcrumb }}</b>
        </ng-container>
      </xng-breadcrumb> -->

<div *ngIf="!showCustomBreadcrumb()"
     class="d-flex justify-content-between align-items-center mb-3">

  <!-- Breadcrumb -->
  <xng-breadcrumb [autoGenerate]="false">
    <ng-container *xngBreadcrumbItem="let breadcrumb">
      <b [routerLink]="breadcrumb.url">{{ breadcrumb }}</b>
    </ng-container>
  </xng-breadcrumb>

  <!-- Add Button -->
  <div *ngIf="showAdminMenuAddButtons">
    <button class="btn custom-buttons-btn"
            [routerLink]="AdminMenuAddButtonRoute">
      {{ AdminMenuAddButtonText }}
    </button>
  </div>

</div>


      <div *ngIf="showCustomBreadcrumb()">

        <!-- Plant Dropdown -->
        <!-- <select class="form-select breadcrumb-text-style"  [style.width.px]="plantDropdownWidth" style="display:inline-block" (ngModelChange)="onPlantChange($event)"
          [(ngModel)]="selectedPlantId">

          <option [ngValue]="null">Select Plant</option>
          <option *ngFor="let plant of (plants$ | async)" [ngValue]="plant.Id">
            {{plant.Name}}
          </option>

        </select>

        <span *ngIf="selectedPlantId && allTrainList.length > 0" class="breadcrumb-separator"> / </span> -->

        <!-- Train Dropdown -->
        <!-- <select class="form-select breadcrumb-text-style" *ngIf="selectedPlantId && allTrainList.length > 0"
          [style.width.px]="trainDropdownWidth" style="display:inline-block" (ngModelChange)="onTrainChange($event)"
          [(ngModel)]="selectedTrainId">

          <option>Select Train</option>

          <option *ngFor="let train of allTrainList" [ngValue]="train.Id">
            {{train.Name}}
          </option>

        </select>

        <span class="breadcrumb-separator">/</span> -->



        <!-- /////////////////////////////////////////////////////////////////////////////////////////////////// -->


        <!-- new code change for plant ddl -->

        <!-- Plant Dropdown Custom -->
        <div class="custom-dropdown" id="plantDropdown">

          <!-- Selected Text + Arrow -->
          <div class="custom-select-box breadcrumb-text-style" [style.width.px]="plantDropdownWidth"
            (click)="togglePlantDropdown()">

            {{ selectedPlantName || 'Select Plant' }}

            <span class="arrow">▼</span>
          </div>

          <!-- Dropdown List -->
          <ul class="custom-dropdown-menu" *ngIf="showPlantDropdown">

            <!-- Search -->
            <li>
              <input type="text" [(ngModel)]="plantSearch" placeholder="Search..." (click)="$event.stopPropagation()">
            </li>

            <li (click)="onPlantSelect(null)">
              Select Plant
            </li>

            <!-- <li *ngFor="let plant of (plants$ | async)" (click)="onPlantSelect(plant)">
              {{ plant.Name }}
            </li> -->
            <li *ngFor="let plant of getFilteredPlants(plants$ | async)" (click)="onPlantSelect(plant)">
              {{ plant.Name }}
            </li>

          </ul>
        </div>

        <span *ngIf="!isTrainAddPage() 
        && selectedPlantId 
        && allTrainList.length > 0" class="breadcrumb-separator">/</span>

        <!-- new code change for train ddl -->
        <!-- Train Dropdown Custom -->
        <div class="custom-dropdown" *ngIf="!isTrainAddPage() && selectedPlantId && allTrainList.length > 0">
          <!-- Selected Train -->
          <div class="custom-select-box breadcrumb-text-style" [style.width.px]="trainDropdownWidth"
            (click)="toggleTrainDropdown()">

            {{ selectedTrainName || 'Select Train' }}

            <span class="arrow">▼</span>
          </div>

          <!-- Train List -->
          <ul class="custom-dropdown-menu train-menu" *ngIf="showTrainDropdown">
            <!-- Train Search -->
                <li>
                  <input type="text" [(ngModel)]="trainSearch" placeholder="Search..." (click)="$event.stopPropagation()">
                </li>

            <li (click)="onTrainSelect(null)">
              Select Train
            </li>

            <li *ngFor="let train of getFilteredTrains(allTrainList)" (click)="onTrainSelect(train)">
              {{ train.Name }}
            </li>

          </ul>
        </div>

        <span *ngIf="!isTrainAddPage() 
      && (isTrainInPlant || isPlantPage() || isTrainPage())
      && !isImportMapPage()
      && !isWarrantyPage()
      && selectedPlantId
      && allTrainList.length > 0" class="breadcrumb-separator">/</span>

        <!-- MENU DROPDOWN -->
        <div *ngIf="!isTrainAddPage() 
      && (isTrainInPlant || isPlantPage() || isTrainPage())
      && !isImportMapPage()
      && !isWarrantyPage()
      && selectedPlantId
      && allTrainList.length > 0" class="menu-dropdown"
          style="display:inline-block">

          <span class="menu-title">
            <b class="breadcrumb-text-style">{{ menuName }}</b>
          </span>

          <ul class="menu-list">

            <li class="has-submenu">
              Operation Data

              <ul class="submenu">
                <li (click)="navigateMenu('Operation Data','Manage Operation Data','/opdata')">
                  Manage
                </li>

                <li (click)="navigateMenu('Operation Data','Import Operation Data','/opdata/import')">
                  Import
                </li>

                <li (click)="navigateMenu('Operation Data','Add Operation Data','/opdata/opdata-add')">
                  Add
                </li>
              </ul>
            </li>

            <li class="has-submenu">
              Event Logs
              <ul class="submenu">
                <li (click)="navigateMenu('Event Logs','Manage Event Logs','/eventlogs')">
                  Manage
                </li>

                <li (click)="navigateMenu('Event Logs','Add Event Logs','/eventlogs/add-eventlogs')">
                  Add
                </li>
              </ul>
            </li>

            <li class="has-submenu">
              Conductivity Profile
              <ul class="submenu">
                <li (click)="navigateMenu('Conductivity Profile','Manage Conductivity Profile','/conductivityprofile')">
                  Manage
                </li>

                <li
                  (click)="navigateMenu('Conductivity Profile','Import Conductivity Profile','/conductivityprofile/import-conductivityprofile')">
                  Import
                </li>

                <li
                  (click)="navigateMenu('Conductivity Profile','Add Conductivity Profile','/conductivityprofile/add-conductivityprofile')">
                  Add
                </li>
              </ul>
            </li>

            <li class="has-submenu">
              Graphs

              <ul class="submenu">
                <li (click)="navigateMenu('Graphs','Primary Graph','graph/primarygraph')">
                  Primary
                </li>

                <li (click)="navigateMenu('Graphs','Custom Graph','/graph/customgraph')">
                  Custom
                </li>

                <li (click)="navigateMenu('Graphs','Comparison Graph','/graph/comparisongraph')">
                  Comparison
                </li>

                <li (click)="navigateMenu('Graphs','Conductivity Graph','/graph/conductivityprofilegraph')">
                  Conductivity Profile
                </li>
              </ul>
            </li>

            <li class="has-submenu">
              Train Details

              <ul class="submenu">
                <li (click)="navigateMenu('Train Details','Train','/trains')">
                  Manage
                </li>

                <!-- <li (click)="navigateMenu('Graphs','Custom Graph','/graph/customgraph')">
                  Custom
                </li> -->

              </ul>
            </li>

            <!-- Commented on 25th May told by Sumedh Sir and Smita Mam -->
            <!-- <li class="has-submenu">
              Project
              <ul class="submenu">
                <li (click)="navigateMenu('Project','Plants','/plants')">
                  Plants
                </li>

                <li (click)="navigateMenu('Project','Train','/trains')">
                  Trains
                </li>

                <li (click)="navigateMenu('Project','Manage Import Maps','/importmaps')">
                  Import Map
                </li>

                <li (click)="navigateMenu('Project','Warranty Condition','/warrantycondition')">
                  Warranties
                </li>
              </ul>
            </li> -->

          </ul>


        </div>

        <span *ngIf="!isTrainAddPage() 
        && ( isTrainInPlant || isPlantPage() || isTrainPage())
        && selectedPlantId
        && allTrainList.length > 0" class="breadcrumb-separator">/</span>

        <b *ngIf="!isTrainAddPage() 
        && (isTrainInPlant || isPlantPage() || isTrainPage())
        && selectedPlantId
        && allTrainList.length > 0" class=" breadcrumb-text-style">{{ subMenuName }}</b>

        <div class="float-end" *ngIf="showAddButton">

          <button class="btn custom-buttons-btn" [routerLink]="addButtonRoute">

            {{ addButtonText }}

          </button>

        </div>
      </div>

      <!-- <p *ngIf="showCustomBreadcrumb() && selectedPlantId && (!allTrainList || allTrainList.length <= 0)"
        style="padding-left: 11px;">No Trains Found !</p> -->


      <p *ngIf="plantValidation && showCustomBreadcrumb()" style="padding-left: 11px; color: red;" >
        Please select a plant
      </p>
      <!-- <router-outlet></router-outlet> -->
<div *ngIf="shouldShowNoTrainPage()">
    <app-no-trains-found-component></app-no-trains-found-component>
</div>

<div [hidden]="shouldShowNoTrainPage()">
    <router-outlet></router-outlet>
</div>

    </div>
  </div>
</div>
